editUserInputAnswerController.$inject = ['$scope', '$uibModalInstance', 'answer', '$translate'];
export function editUserInputAnswerController($scope, $uibModalInstance, answer, $translate) {

  $scope.editAnswer = editAnswer;
  $scope.cancel = cancel;
  $scope.answer = answer;
  init();

  function editAnswer({ hasHandover }) {
    $uibModalInstance.close({ hasHandover });
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {
    $scope.handoverMessage = $translate.instant('parameters/quick_replies/details/edit_answer/transfer_tooltip');
  }
}
